<header class="h-100 w">
  <mdb-navbar SideClass="navbar fixed-top navbar-expand-lg navbar-dark scrolling-navbar intro-fixed-nav" [containerInside]="false">
    <mdb-navbar-brand>
      <a class="logo navbar-brand" [routerLink]="['/home']" fragment="aboutAsips">
        <strong>Asips</strong>
      </a>
    </mdb-navbar-brand>
    <links>
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/home">Home
            <span class="sr-only">(current)</span>
          </a>
        </li>
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/verify">Verify</a>
        </li>
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/view_pulsar">View Pulsar Signals</a>
        </li>
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/view_pulsar_non_pulsar">View Pulsar & non Pulsar Signals</a>
        </li>
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/test_with_another_algorithm">Test with Another Algorithm</a>
        </li>
        <li class="nav-item active waves-light mr-lg-2" mdbWavesEffect>
          <a class="nav-link" routerLink="/help">About</a>
        </li>
      </ul>
    </links>
  </mdb-navbar>
  <!-- Main -->

    <div class="view ">
      <div class="full-bg-img">

        </div>
      </div>


  <!-- /.Main -->

</header>
<!--Main Navigation-->

